<template>
  <base-modal
    :customShowDialog="showNewConfirmationModal"
    :confirmeEnabled="true"
    :confirmButton="$t('modal.newCanvasConfirmation.confirmBtn')"
    :title="$t('modal.newCanvasConfirmation.title')"
    @confirmed="$emit('confirmed')"
    @close="handleClose"
  >
    <div slot="body">
      <span class="modal-text" v-html="$t('modal.newCanvasConfirmation.message')"></span>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from '../modals/BaseModal'

export default {
  name: 'new-canvas-confirmation-modal',
  components: {BaseModal},
  props: ['customShowDialog'],
  computed: {
    showNewConfirmationModal: { get () { return this.$store.state.modalState.showNewConfirmationModal } }
  },
  methods: {
    handleClose () {
      this.$store.commit('setShowNewConfirmationModal', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mainMenu/NewCanvasConfirmationModal.vue